import { createDomainPagedAutoCompleteMetaData } from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IAddPaperGoodsReceipt } from "mobx-stores/_models/paper-inventory/paper-goods-receipt/paper-goods-receipt";
import { date, number, string } from "yup";

export const getAddPaperGoodsReceiptSchema =
  (): ObjectSchemaType<IAddPaperGoodsReceipt> => ({
    receiptDate: {
      type: InputType.datePicker,
      gridSize: 12,
      label: "Ngày nhập",
      validattionYupSchema: date().required(),
    },
    items: {
      arraySchema: {
        materialId: {
          type: InputType.autoComplete,
          gridSize: 12,
          label: "Vật tư giấy",
          validattionYupSchema: string().required(),
          metaData: createDomainPagedAutoCompleteMetaData("paper"),
        },
        rollNumber: {
          type: InputType.text,
          gridSize: 12,
          label: "Số cuồn",
          validattionYupSchema: string().max(128),
        },
        amount: {
          type: InputType.number,
          gridSize: 6,
          label: "Số lượng",
          validattionYupSchema: number().required(),
          defaultValue: 0,
          metaData: {
            fixDecimalScale: 1,
          },
        },
        wareHouse: {
          type: InputType.text,
          gridSize: 6,
          label: "Vị trí kho",
          validattionYupSchema: string().required().max(128),
        },
        brand: {
          type: InputType.text,
          gridSize: 6,
          label: "Hiệu",
          validattionYupSchema: string().required().max(128),
        },
        serialNumber: {
          type: InputType.text,
          gridSize: 6,
          label: "Số seri",
          validattionYupSchema: string().required().max(128),
        },
        origin: {
          type: InputType.text,
          gridSize: 6,
          label: "Xuất xứ",
          validattionYupSchema: string().max(128),
        },
        supplier: {
          type: InputType.text,
          gridSize: 6,
          label: "Nhà cung cấp",
          validattionYupSchema: string().max(128),
        },
        document: {
          type: InputType.text,
          gridSize: 12,
          label: "Chứng từ",
          validattionYupSchema: string().max(128),
        },
        note: {
          type: InputType.textArea,
          gridSize: 12,
          label: "Ghi chú",
          validattionYupSchema: string().max(512),
        },
      },
    },
  });
